import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=ffa1514c&scoped=true"
import script from "./HelpDetail.vue?vue&type=script&lang=js"
export * from "./HelpDetail.vue?vue&type=script&lang=js"
import style0 from "./HelpDetail.vue?vue&type=style&index=0&id=ffa1514c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1514c",
  null
  
)

export default component.exports